// extracted by mini-css-extract-plugin
export var Header = "style-module--Header--xJBv8";
export var PayrollLogo = "style-module--PayrollLogo--2042G";